// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"874":"9d7cb46c","919":"9eacad51"}[chunkId] + ".js";
};